/* eslint-disable max-lines */
import { styled } from 'styled-components';

interface CoverProps {
    background?: string;
    height?: string;
}
type iconTypeProps ='square' | 'rectangle'
interface IconProps {
    type?: iconTypeProps;
}

interface ProductCardBoxProps {
    hasIcon: boolean;
}

export const EditBox = styled.a`
    position: absolute;
    top: 15px;
    right: -60px;
    opacity: 0;
    pointer-events: none;
    transition: all 0.1s ease-in-out;
    z-index: 1;
    width:30px;
    height: 30px;
    background: ${({ theme }) => theme.colors.card.background};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')} !important;
`;

export const ActionButtonsWrapper = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    gap: 6px;
`;

export const CardActionButton = styled.button<{ $variant?: 'default' | 'danger' }>`
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: ${({ theme }) => theme.colors.card.background};
    border-radius: 6px;
    border: none;
    transition: all 0.2s ease-in-out;
    opacity: 0.85;

    svg {
        color: ${({ theme, $variant }) => ($variant === 'danger'
    ? theme.colors.danger[500]
    : theme.colors.text.secondary)};
    }

    &:hover {
        opacity: 1;
        background: ${({ theme, $variant }) => {
    if ($variant === 'danger') {
      return theme.mode === 'dark' ? 'rgba(239, 68, 68, 0.2)' : '#fef2f2';
    }
    return theme.mode === 'dark' ? '#374151' : '#f3f4f6';
  }};
        transform: translateY(-1px);
    }

    &:active {
        transform: scale(0.95);
    }
`;

export const EventCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    border-radius: 6px;
    background: ${({ theme }) => theme.colors.card.background};
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? '0 4px 12px rgba(0, 0, 0, 0.2)'
    : '0 4px 12px rgba(0, 0, 0, 0.05)')};
    transition: all 0.3s ease;
    border: 1px solid ${({ theme }) => theme.colors.card.border};
`;

export const Cover = styled.div<CoverProps>`
    width: 100%;
    height: ${(props) => props.height || '200px'};
    overflow: hidden;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    background-image: url(${(props) => props.background});
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
    position: relative;
`;

export const EventCardBox = styled.div<ProductCardBoxProps>`
    width: 100%;
    height: ${(props) => (props.hasIcon ? '130px' : '130px')};
    background: ${({ theme }) => theme.colors.card.background};
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')} !important;
    padding:  ${(props) => (props.hasIcon ? '10px 20px 10px 20px' : '15px 20px')};
    position:relative;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:flex-start;
    gap:10px;
`;

export const Title = styled.h3`
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.primary};
    line-height: 1.4;
    display:flex;
    align-items:center;
`;

export const Subtitle = styled.p`
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.primary};
    margin:0!important;
`;

export const Description = styled.p`
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.secondary};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const IconWrapper = styled.div<IconProps>`
    width: auto;
    padding: 5px 8px;
    height: 30px;
    position: absolute;
    bottom: 10px;
    left: 15px;
    border-radius: ${(props) => (props.type === 'square' ? '50%' : '6px')};
    background: rgba(0, 0, 0, 0.8);
    border: 2px solid rgba(255, 255, 255, 0.7);
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(225, 229, 238, 0.1) 0 2px 6px')} !important;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 12px;
    color: #fff;
    justify-content: center;
    transition: all 0.3s ease;
`;

export const RegisterUserWrapper = styled.div<IconProps>`
    width: 60px;
    height: 30px;
    position: absolute;
    bottom:15px;
    right: 15px;
    border-radius: ${(props) => (props.type === 'square' ? '50%' : '6px')};
    background: ${({ theme }) => theme.colors.card.background};
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')} !important;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: all 0.3s ease;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.text.primary};
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    }
`;

export const BubleWhite = styled.div`
    width: 18px;
    height: 18px;
    top:15px;
    right: -8px;
    z-index: 2;
    background: ${({ theme }) => theme.colors.card.background};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: 50%;
    position: absolute;
`;

export const BubleBlack = styled.div`
    width: 18px;
    height: 18px;
    top:15px;
    right: -8px;
    z-index: 2;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#fff' : '#000')};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: 50%;
    position: absolute;
`;

export const StatusWrapper = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
`;

export const SkeletonOverlay = styled.div<{ height?: string }>`
  position: absolute;
  inset: 0;
  background-color: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e0e0e0')};
  background: ${({ theme }) => (theme.mode === 'dark'
    ? 'linear-gradient(90deg, #374151 25%, #4b5563 50%, #374151 75%)'
    : 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)')};
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  @keyframes shimmer {
    from { background-position: -200% 0; }
    to   { background-position: 200% 0; }
  }
`;
